import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'Components/tooltip';
import getPrefixedNumberFormat
  from 'Utils/numeric/getPrefixedNumberFormat';
import * as styles from './tableCell.css';

// This doesn't use a stateful but ag-grid requires it :(
// eslint-disable-next-line react/prefer-stateless-function
class TableCell extends Component {
  render() {
    const {
      value: {
        value = '',
        formatted = '',
        align = 'left',
        footnotes = [],
      },
      data: {
        characteristic,
      },
      colDef: {
        headerName,
      },
    } = this.props;

    if (!value) {
      return <div className={styles.cell} />;
    }

    const btnProps = {
      className: styles.btn || '',
      content: '*',
    };

    return (
      <div className={styles.cell} style={{ textAlign: align }}>
        <span className={styles.value}>
          {getPrefixedNumberFormat(formatted)}
        </span>
        {0 < footnotes.length &&
          (<Tooltip
            btnProps={btnProps}
            content={footnotes
              .map(({ value: text }) => text)
              .reduce((acc, val) => acc.concat(val), [])}
            title={`Footnotes for ${characteristic} in ${headerName}`}
          />)}
      </div>
    );
  }
}

TableCell.defaultProps = {
  value: {
    value: '',
    align: 'left',
    formatted: '',
    footnotes: [],
  },
};

TableCell.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
    align: PropTypes.string,
    footnotes: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
  }),
  data: PropTypes.shape({
    characteristic: PropTypes.string.isRequired,
  }).isRequired,
  colDef: PropTypes.shape({
    headerName: PropTypes.string.isRequired,
  }).isRequired,
};

export default TableCell;



// WEBPACK FOOTER //
// ./app/components/tableCell/index.js